import { useState, useEffect } from "react";
import { checkForTimeConflicts } from "@/components/booking/utils/timeConflictUtils";
import { isSlotWithinOperatingHours } from "@/components/booking/utils/timeSlotUtils";

export const useTimeSelection = (
  selectedTimeSlot: string,
  selectedDate: Date | undefined,
  serviceId: number,
  operatingHours: any[] = []
) => {
  const [startTime, setStartTime] = useState(selectedTimeSlot || "");
  const [endTime, setEndTime] = useState("");
  const [conflictError, setConflictError] = useState<string | null>(null);
  const [outsideOperatingHoursError, setOutsideOperatingHoursError] = useState<string | null>(null);

  useEffect(() => {
    console.log('useTimeSelection - selectedTimeSlot:', selectedTimeSlot);
    console.log('useTimeSelection - startTime:', startTime);
    console.log('useTimeSelection - endTime:', endTime);
    
    setStartTime(selectedTimeSlot || "");
  }, [selectedTimeSlot]);

  // Check for time conflicts with existing bookings
  useEffect(() => {
    if (startTime && endTime) {
      checkForTimeConflicts(selectedDate, startTime, endTime, serviceId)
        .then(error => setConflictError(error));
    } else {
      setConflictError(null);
    }
  }, [startTime, endTime, selectedDate, serviceId]);

  // Check if selected times are within operating hours
  useEffect(() => {
    if (startTime && endTime && selectedDate && operatingHours.length > 0) {
      const startWithinHours = isSlotWithinOperatingHours(startTime, selectedDate, operatingHours);
      const endWithinHours = isSlotWithinOperatingHours(endTime, selectedDate, operatingHours);
      
      if (!startWithinHours || !endWithinHours) {
        setOutsideOperatingHoursError("Selected time is outside service operating hours.");
      } else {
        setOutsideOperatingHoursError(null);
      }
    } else {
      setOutsideOperatingHoursError(null);
    }
  }, [startTime, endTime, selectedDate, operatingHours]);

  const resetTimeSelection = () => {
    setStartTime(selectedTimeSlot || "");
    setEndTime("");
    setConflictError(null);
    setOutsideOperatingHoursError(null);
  };

  return {
    startTime,
    endTime,
    conflictError,
    outsideOperatingHoursError,
    setStartTime,
    setEndTime,
    resetTimeSelection
  };
};